import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  note: null,
  notes: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const noteReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.NOTE_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.NOTE_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.NOTE_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default noteReducer;
